<template>
  <div class="tribute-gallery">
    <TributeItem transition="stagger" stagger="100"
      v-for="(tribute, index) in tributes"
      v-bind:key="index"
      v-bind:tribute="tribute"
      :class="`item-${index % 2} tribute-list`" />
  </div>
</template>

<script>
import TributeItem from '@/components/TributeItem.vue';

export default {
  name: 'TributeGallery',
  components: {
    TributeItem,
  },
  data() {
    return {
      currentPage: 0,
    };
  },
  props: {
    tributes: {
      type: Array,
      required: true,
    },
  },
};
</script>
